import React, { useEffect, useState } from 'react'
import Button from '../../components/ButtonNew'
import ArrowRightIcon from '../../assets/icons/common/arrow-right.svg'
import moveToStore from '../../utils/helpers/deviceType'
import Layout from '../../components/Layout'
import Text from '../../components/Text'
import WomanThumbsUp from '../../assets/images/success/woman-thumbs-up.png'
import MetabolicScore from '../../assets/images/success/metabolic-score.png'
import FlowerRightSideImg from '../../assets/images/success/flower-right-side.png'
import FlowerLeftSideImg from '../../assets/images/success/flower-left-side.png'
import GoodFlipLogoWhite from '../../assets/images/logos/goodflip-logo-white.png'
import { getUrlParams } from '../../utils/helpers/common'
import Lottie from 'react-lottie'
import * as successTickAnimationData from '../../assets/animations/success-tick.json'
import * as crackersAnimationData from '../../assets/animations/crackers-horizontal.json'
import TickIcon from '../../assets/icons/tick.svg'
import constants from '../../constants'
import { GOODFLIP_CONFIG } from '../../constants/goodflip-configs'
import { DIASENS_CONFIG } from '../../constants/diasens-configs'
import { GLUCOLIVE_CONFIG } from '../../constants/glucolive-configs'
import { getCgmTypeFromHostname } from '../../utils/helpers/cgmHostname'

const CGM_CONFIGS = {
  [constants.CGM_TYPE.GOODFLIP]: GOODFLIP_CONFIG,
  [constants.CGM_TYPE.DIASENS]: DIASENS_CONFIG,
  [constants.CGM_TYPE.GLUCOLIVE]: GLUCOLIVE_CONFIG,
}

const SignupSuccess = () => {
  const params = getUrlParams()
  const cgmType =
    params?.cgm ||
    (!params?.support_program_type ? getCgmTypeFromHostname() : undefined)
  const isCgmFlow = Boolean(params?.cgm) || Boolean(CGM_CONFIGS[cgmType])

  const [showTick, setShowTick] = useState(false)
  const [animationCount, setAnimationCount] = useState(0)

  // Determine which program config to show
  const displayProgram = isCgmFlow
    ? CGM_CONFIGS[cgmType]
    : params.support_program_type
      ? (() => {
          // Lazy load supportProgramTypes only for PSP flow
          const {
            supportProgramTypes,
          } = require('../../constants/support-programs')
          return supportProgramTypes[params.support_program_type]
        })()
      : null

  useEffect(() => {
    localStorage.removeItem('auth_token')
  }, [])

  const handleDownloadClick = () => {
    // window.open('https://goodflip.com', '_blank')
    console.log('download')
    moveToStore('https://dl.mytatva.in')
  }

  const handleAnimationComplete = () => {
    setAnimationCount((prev) => {
      if (prev + 1 >= 2) {
        setShowTick(true)
        return 0
      }
      return prev + 1
    })
  }

  const successTickAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: successTickAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  const crackersAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: crackersAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return (
    <Layout>
      <div className="min-w-sm max-w-lg relative mx-auto w-full h-screen overflow-y-auto pb-[98px] bg-[#009856] flex flex-col items-center">
        <div className="relative w-full top-20 z-0">
          <div className="absolute -top-14 left-0 right-0 bg-white shadow-md z-10 rounded-full w-[100px] h-[100px] mx-auto flex items-center justify-center">
            {!showTick ? (
              <>
                <Lottie
                  options={successTickAnimationOptions}
                  height={100}
                  width={100}
                  eventListeners={[
                    {
                      eventName: 'complete',
                      callback: handleAnimationComplete,
                    },
                  ]}
                />
              </>
            ) : (
              <img src={TickIcon} alt="tick" className="w-10 h-10" />
            )}
          </div>

          {!showTick && (
            <div className="absolute -z-10 -top-20 left-0 w-full">
              <Lottie
                options={crackersAnimationOptions}
                height={100}
                width={'100%'}
              />
            </div>
          )}
          <img
            src={FlowerLeftSideImg}
            className="absolute -z-10 top-0 bottom-0 my-auto left-0 h-[210px]"
          />
          <img
            src={FlowerRightSideImg}
            className="absolute -z-10 top-0 bottom-0 my-auto right-0 h-[210px]"
          />
          <div className="z-10 mx-9 bg-white rounded-xl flex flex-col items-center justify-center overflow-hidden">
            <Text
              variant="title"
              size="large"
              tag="h2"
              className="text-[#101828] mt-14 px-4"
              textalign="center"
            >
              {displayProgram?.success_title || (
                <>
                  Welcome to the <br />
                  {displayProgram?.name}
                </>
              )}
            </Text>
            <img
              src={displayProgram?.success_image || WomanThumbsUp}
              className="object-scale-down"
              width={displayProgram?.success_image_width || 200}
              alt="woman-thumbs-up"
            />

            <div className="flex items-center justify-center w-full mt-3">
              {displayProgram?.showMetabolicScore !== false && (
                <img
                  src={MetabolicScore}
                  alt="metabolic-score"
                  className="h-full w-auto object-contain"
                />
              )}
              <div className="flex-1 flex flex-col pt-2 px-4 pb-5">
                <div className="pt-2 pb-5">
                  <Text
                    variant="body"
                    size="medium"
                    tag="p"
                    className="text-[#667085] mb-1"
                  >
                    Next Steps
                  </Text>
                  <Text
                    variant="label"
                    size="medium"
                    tag="p"
                    className="text-[#101828]"
                  >
                    Download the GoodFlip app by tapping on the button below and
                    continue your journey
                  </Text>
                </div>
                <div>
                  <Text
                    variant="body"
                    size="medium"
                    tag="p"
                    className="text-[#667085]"
                  >
                    <span className="text-[#667085]">Note:</span>{' '}
                    <span className="text-[#101828] font-bold">
                      Use the same phone number you registered with to log in
                    </span>
                  </Text>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-28 pb-20 flex items-center flex-col gap-6">
          {/* For CGM flow, don't show partner logo. For PSP, only show if not standalone GoodFlip */}
          {displayProgram?.logoWhite && displayProgram?.success_message ? (
            <>
              <div className="relative flex items-end gap-6">
                <img
                  src={GoodFlipLogoWhite}
                  alt="goodflip-logo"
                  height={24}
                  width={115}
                />
                <div className="h-6 w-[1px] bg-white mt-10" />
                <img
                  src={displayProgram?.logoWhite}
                  alt="support-program-logo"
                  height={24}
                  width={85}
                />
              </div>
              <div className="w-full top-44">
                <Text
                  variant="label"
                  size="medium"
                  tag="p"
                  className="text-white text-center"
                  textalign="center"
                >
                  {displayProgram?.success_message()}
                </Text>
              </div>
            </>
          ) : null}
          <div className="fixed bottom-0 left-0 right-0 p-4 min-w-sm max-w-lg mx-auto w-full bg-white">
            <Button fullWidth onClick={handleDownloadClick}>
              Download GoodFlip App{' '}
              <img src={ArrowRightIcon} alt="arrow-right" />
            </Button>
          </div>
        </div>
        {/* <img src={SignupSuccessImg} alt="success" />

        <div className="fixed bottom-0 left-0 right-0 p-4 min-w-sm max-w-lg mx-auto w-full bg-white">
          <Button fullWidth onClick={handleDownloadClick}>
            Download GoodFlip App <img src={ArrowRightIcon} alt="arrow-right" />
          </Button>
        </div> */}
      </div>
    </Layout>
  )
}

export default SignupSuccess
